/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.

==========================================================================================*/

export default [
  {
    header: 'Dashboard',
    items: [
      {
        url: '/dashboard',
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'HomeIcon'
      }
    ]
  },
  {
    header: 'Practice',
    items: [
      {
        url: '/learn',
        name: 'Learn',
        slug: 'learn',
        icon: 'PlayIcon'
      },
      {
        url: '/activity/flashcards',
        name: 'Flashcards',
        slug: 'flashcard',
        icon: 'CopyIcon'
      }
    ]
  },
  {
    header: 'Progress',
    rule: 'user',
    items: [
      {
        url: '/select-course',
        name: 'Courses',
        slug: 'course-selector',
        rule: 'user',
        icon: 'BookIcon'
      }
      // {
      //   url: '/simulation/bookmarks',
      //   name: 'Bookmarks',
      //   slug: 'simulation-bookmarks',simulations/legacy
      //   icon: 'BookmarkIcon'
      // }
    ]
  },
  {
    header: 'Management',
    rule: 'proctor',
    items: [
      {
        url: '/a/users',
        name: 'Users',
        slug: 'management-users',
        icon: 'UsersIcon',
        rule: 'proctor'
      },
      {
        url: '/a/groups',
        name: 'Groups',
        slug: 'management-users-groups',
        icon: 'TagIcon',
        rule: 'proctor'
      },
      {
        url: '',
        name: 'Guard',
        slug: 'management-guard',
        icon: 'ShieldIcon',
        rule: 'disabled'
      }
    ]
  },
  {
    header: 'Billing',
    rule: 'admin',
    items: [

      {
        url: '/a/subscriptions',
        name: 'Subscriptions',
        slug: 'management-subscriptions',
        rule: 'admin',
        icon: 'CreditCardIcon'
      }
    ]
  },
  {
    header: 'Content',
    rule: 'proctor',
    items: [
      {
        url: '/a/courses',
        name: 'Courses',
        slug: 'management-courses',
        icon: 'BookIcon',
        rule: 'proctor'
      },
      {
        url: '/a/domains',
        name: 'Domains',
        slug: 'management-domains',
        icon: 'PackageIcon'
      },
      {
        url: '/a/sets',
        name: 'Sets',
        slug: 'management-sets',
        icon: 'LayersIcon'
      },
      {
        url: '/a/terms',
        name: 'Terms',
        slug: 'management-lessons',
        icon: 'InboxIcon'
      }
    ]
  },
  {
    header: 'Practice Mode',
    rule: 'proctor',
    items: [
      {
        url: '/a/lessons',
        name: 'Lessons',
        slug: 'management-lessons',
        icon: 'FileTextIcon'
      },
    ]
  }
]

